import {Inject, injectable} from 'inversify-props';

import {Device} from '@/model/network/device/Device';
import {DeviceFactory} from '@/model/network/device/DeviceFactory';

import {INetworkDeviceService} from '@/services/network/INetworkDeviceService';
import {IApiService} from '@/services/IApi.service';

@injectable()
export class NetworkDeviceService implements INetworkDeviceService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/network/device';

  public async readAll(): Promise<Device[]> {
    const devicesData = await this.apiService.get(this.path);

    return devicesData.map((d: any) => DeviceFactory.CreateDevice(d));
  }

  public async read(interfaceName: string): Promise<Device> {
    return DeviceFactory.CreateDevice(await this.apiService.get(`${this.path}/${interfaceName}`));
  }

  public async reapply(interfaceName: string): Promise<void> {
    return this.apiService.post(`${this.path}/${interfaceName}/reapply`, null);
  }

  public async disconnect(interfaceName: string): Promise<void> {
    return this.apiService.post(`${this.path}/${interfaceName}/disconnect`, null);
  }

  public async delete(interfaceName: string): Promise<void> {
    return this.apiService.delete(`${this.path}/${interfaceName}`);
  }

  public async setStatisticsRefreshRate(interfaceName: string, refreshRate: number): Promise<void> {
    return this.apiService.put(`${this.path}/${interfaceName}/statistics/refresh-rate`, refreshRate);
  }
}
